import utils from 'utils'

class downLoadPageCtrl {
    constructor($scope, $uibModalInstance, items1, redInfoService, logger, $timeout, $filter) {
        const diskList = JSON.parse(localStorage.user_info).sysUkeyList
        $scope.diskList = [diskList[0]]
        diskList.forEach(disk => {
            let flag = true
            $scope.diskList.forEach(i => {
                if (disk.diskCode == i.diskCode) flag = false
            })
            flag && $scope.diskList.push(disk)
        })
        $scope.modaldata = items1
        $scope.selectedRows = []
        $scope.modaldata.isFilterCollapsed = false
        // 列表数据
        $scope.modaldata.redBillData = []
        // 分页参数
        $scope.pageOpt2 = {
            totalItems: 0, // 组件初始化设置总页数
            currentPage: 1, // 设置显示第一页
            maxSize: 10, // 每一叶显示记录数
        }
        const nowDate = new Date()
        const nowDateStr = $filter('date')(nowDate, 'yyyy-MM-dd')
        nowDate.setDate(1)
        // 初始化参数
        $scope.modaldata.param = {
            custCreditCode: '',
            saleCreditCode: '',
            invoiceDateMax: nowDateStr,
            invoiceDateMin: $filter('date')(nowDate, 'yyyy-MM-dd'),
            infoCode: '',
            invInfoFw: '',
            totalItems: 0,
            pageNo: 1,
            pageSize: 10,
            disk: $scope.diskList[0],
            mock: isMock
        }
        $scope.invInfoFwArr = [false, false]
        $scope.downloadFwChange = function downloadFwChange() {
            $timeout(() => {
                if ($scope.invInfoFwArr[0]) {
                    $scope.modaldata.param.invInfoFw = 1
                }
                if ($scope.invInfoFwArr[1]) {
                    $scope.modaldata.param.invInfoFw = 2
                }
                if ($scope.invInfoFwArr[0] && $scope.invInfoFwArr[1]) {
                    $scope.modaldata.param.invInfoFw = 0
                }
                if (!$scope.invInfoFwArr[0] && !$scope.invInfoFwArr[1]) {
                    $scope.modaldata.param.invInfoFw = ''
                }
            })
        }
        let querying = false

        function queryInvoiceList() {
            if (querying) {
                return
            }
            if ($scope.modaldata.param.invInfoFw === '') {
                logger.logError('请选择一个下载范围')
                return
            }
            if (!$scope.modaldata.param.disk) return logger.logError('您还没有配置开票点，不能进行该操作')
            querying = true
            $scope.modaldata.param.diskCode = $scope.modaldata.param.disk.diskCode
            redInfoService.queryDownload($scope.modaldata.param).then((queryResult) => {
                querying = false
                $scope.selectedRows = []
                $scope.modaldata.param.totalItems = queryResult.total
                $scope.modaldata.redBillData = queryResult.list
            }, (err) => {
                logger.logError(err)
            }).finally(() => {
                querying = false
            })
        }
        // 分页
        $scope.pageChanged2 = function pageChanged2() {
            queryInvoiceList()
        }
        // 搜索
        $scope.searchBlueInvoice = function searchBlueInvoice() {
            queryInvoiceList()
        }
        // 关闭
        $scope.cancel = function cancel() {
            $uibModalInstance.dismiss('cancel')
        }
        $scope.downloadRedInfo = function downloadRedInfo() {
            // 返回数据
            const {
                selectedRows
            } = $scope
            if (selectedRows.length === 0) {
                logger.logError('请选择要下载的数据')
                return
            }
            // 插入本地数据库
            utils.loading('正在下载中，请耐心等待')
            redInfoService.download(selectedRows).then((res) => {
                utils.loaded()
                logger.logSuccess(res.data.message)
                $uibModalInstance.close()
            })
        }
    }
}

downLoadPageCtrl.$inject = ['$scope', '$uibModalInstance', 'items1', 'redInfoService', 'logger', '$timeout', '$filter']
export default downLoadPageCtrl


// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/redWordInfo/downLoadPageCtrl.js